import React from 'react';
import Hero from '../components/Hero';
import CategoryGrid from '../components/CategoryGrid';
import FeaturedProviders from '../components/FeaturedProviders';
import VendorCTA from '../components/VendorCTA';
import Testimonials from '../components/Testimonials';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';

export default function Home() {
  return (
    <>
      <Hero />

      <section className="section">
        <div className="section-header">
          <h2>¿Qué necesitas para tu fiesta de XV años?</h2>
          <p>Explora nuestras categorías más buscadas por otras familias.</p>
        </div>
        <CategoryGrid limit={8} />
        <div className="section-cta">
          <Link to="/categorias" className="btn btn-outline">Ver todas las categorías</Link>
        </div>
      </section>

      <FeaturedProviders />
      <VendorCTA />
      <Testimonials />

      <section className="section">
        <div className="section-header">
          <h2>Ideas y consejos</h2>
          <p>Inspírate con nuestros artículos para planear la fiesta perfecta.</p>
        </div>
        <div className="blog-grid">
          {blogPosts.slice(0, 3).map((post) => (
            <Link to={`/blog/${post.slug}`} className="blog-card" key={post.slug}>
              <img src={post.image} alt={post.title} loading="lazy" />
              <div className="blog-card-body">
                <span className="blog-category">{post.category}</span>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
        <div className="section-cta">
          <Link to="/blog" className="btn btn-outline">Ver todos los artículos</Link>
        </div>
      </section>
    </>
  );
}
